import { toast } from "react-toastify";
import { createSlice } from '@reduxjs/toolkit';
import InsuranceService from "../../services/InsuranceService";

interface APIResponse {
    data: {
        status: number,
        message: string,
        data?: any
    }
}

const Insurance = createSlice({
    name: 'insurance',
    initialState: {
        insuranceList: {},
        leadDetail: {},
        leadEmiDetail: {}
    },
    reducers: {
        insuranceList: (state, action) => {
            state.insuranceList = action.payload
        },
        leadDetail: (state, action) => {
            state.leadDetail = action.payload
        },
        leadEmiDetail: (state, action) => {
            state.leadEmiDetail = action.payload
        }
    }
})

export default Insurance.reducer;

const { insuranceList,leadDetail,leadEmiDetail } = Insurance.actions


/**
 * Function to make API call to fetch insurance listing
 * @param params 
 * @returns 
 */
export const getInsuranceList = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {        
        InsuranceService.getInsuranceListing(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                        dispatch(insuranceList(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const updateLeadAssignUser = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.updateLeadAssignUser(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        if (response.data.message) toast.success(response.data.message);
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const fetchLeadProcessingDetails = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {        
        InsuranceService.fetchLeadProcessingDetails(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response?.data?.data)
                        dispatch(leadDetail(response?.data?.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const fetchLeadProcessingEmiDetails = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {        
        InsuranceService.fetchLeadProcessingEmiDetails(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response?.data?.data)
                        dispatch(leadEmiDetail(response?.data?.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const getLeadHistory = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.getLeadHistory(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                    }
                    else {
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const updateLeadEmiDetail = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.updateLeadEmiDetail(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        if (response.data.message) toast.success(response.data.message);
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const updatePaymentMethod = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.updatePaymentMethod(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                    }
                    else {
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const updateFollowupStatus = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.changeFollowupStatus(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        if (response.data.message) toast.success(response.data.message);
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const sendForReferralPayout = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.sendForReferralPayout(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                    }
                    else {
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const getReferralPayout = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.getReferralPayout(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                    }
                    else {
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const updateLeadPaymentConfig = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.updateLeadPaymentConfig(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        if (response.data.message) toast.success(response.data.message);
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const bulkLeadAssignee = async (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.bulkLeadAssignee(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        toast.success(response.data.message);
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const triggerPaymentEmail = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.triggerPaymentEmail(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        if (response.data.message) toast.success(response.data.message);
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const downLoadQrCode = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.downLoadQrCode(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        if (response.data.message) toast.success(response.data.message);
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const offsetAgentCommission = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.offsetAgentCommission(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        if (response.data.message) toast.success(response.data.message);
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}
